import { ImmerGet, ImmerSet } from '../types';

import { getLastLoadedCustomCxdDialogManager } from '@/components/dynamic-flow-editor/loaded-custom-cxd-dialog-manager';
import { EditableBotVersionSlice } from '@/domain/bot';
import {
    postConversationTasks,
    postVoicebotCall,
} from '@/services/api/campaigns';

/**
 * Creates test call action handlers.
 */
export const createTestCallActions = (
    set: ImmerSet,
    get: ImmerGet,
): Pick<
    EditableBotVersionSlice,
    | 'resetCurrentConversationTaskId'
    | 'sendVoicebotCall'
    | 'sendConversationTask'
> => ({
    resetCurrentConversationTaskId: () => {
        set((state) => {
            state.currentConversationTaskId = undefined;
        });
    },

    sendVoicebotCall: async (
        callee: {
            phone: string;
            phonePrefix: string;
        },
        campaignId: string,
        botId: string,
    ) => {
        try {
            const { conversation_task_ids } = await postVoicebotCall(
                campaignId,
                botId,
                callee,
                get().editingBot.taskValues,
            );

            set((state) => {
                state.currentConversationTaskId = conversation_task_ids[0];
            });
        } catch (e) {
            console.log('Error posting voicebot call', e);
        }
    },

    sendConversationTask: async (
        callee: { phone: string; phonePrefix: string },
        accountId?: string,
    ) => {
        const bot = get().editingBot;
        const currentBot = {
            botId: bot.botId,
            botVersionId: bot.botVersionId,
            name: bot.name,
            description: bot.description,
            voiceConfig: bot.voiceConfig,
            smsConfig: bot.smsConfig,
            language: bot.language,
            channel: bot.channel,
            nodesReactFlow: bot.nodesReactFlow,
            selectedHandle: bot.selectedHandle,
            edgesReactFlow: bot.edgesReactFlow,
            taskValues: bot.taskValues,
            labels: bot.labels,
            stickers: bot.stickers,
            mchannelsBotId: bot.mchannelsBotId,
        };

        try {
            const { conversation_task_ids } = await postConversationTasks(
                bot.botId,
                {
                    currentBot: currentBot,
                    callee: callee,
                    // In-session Settings selection; API falls back to mappie.
                    dialogManager: getLastLoadedCustomCxdDialogManager(),
                },
                accountId,
            );

            set((state) => {
                state.currentConversationTaskId = conversation_task_ids[0];
            });
        } catch (e) {
            console.error('Error posting conversation task', e);
            throw e;
        }
    },
});
